export default __webpack_public_path__ + "static/media/diversity_staff_millennial.47106eee.jpg";